<template>
  <div class="container-fluid">
    <div class="search-wrapper" v-if="isSearch">
      <div class="search">
        <search @select="setItem($event)" no-toggle></search>
      </div>
    </div>
    <b-sidebar
      id="sidebar-backdrop"
      backdrop-variant="dark"
      backdrop
      shadow
      right
      :visible="open"
      width="60%"
      bg-variant="dark"
      text-variant="light"
      no-close-on-route-change
      class="p-2"
      lazy
      @hidden="$router.push({ name : 'Archive' })"
    >
      <router-view></router-view>
    </b-sidebar>
  </div>
</template>

<script>
  import Vuex from 'vuex'
  import Search from '@/components/Search'

  export default {
    name: "All",
    components: { Search },
    computed: {
      ...Vuex.mapGetters([
        'isSearch'
      ]),
      open() {
        return this.$route.name !== 'Archive'
      }
    },
    mounted() {
      if (!this.isSearch)
        this.toggleSearch()
    },
    methods: {
      ...Vuex.mapMutations([
        'toggleSearch',
      ]),
      setItem(item) {
        this.item = item
        this.$router.push('/archive/' + item.SYS_GUID)
      },
    }
  }
</script>

<style scoped>

</style>
